export default "__VITE_ASSET__9469044c__"